import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menuRadio", "totalDuration", "durationText"]

  updateLinks() {
    const selected = this.menuRadioTargets.find((r) => r.checked)
    const additionalMenuId = selected?.value || ""
    const additionalDuration = selected?.dataset.duration
      ? parseInt(selected.dataset.duration, 10)
      : 0

    // トレーナーカードリンクのURLパラメータを更新
    document
      .querySelectorAll('[data-extension-toggle-target="trainerLink"]')
      .forEach((link) => {
        const url = new URL(link.href)
        if (additionalMenuId) {
          url.searchParams.set("additional_menu_id", additionalMenuId)
        } else {
          url.searchParams.delete("additional_menu_id")
        }
        link.href = url.toString()
      })

    // 合計時間表示を更新
    if (this.hasDurationTextTarget) {
      if (additionalDuration > 0) {
        this.durationTextTarget.textContent = ` + ${additionalDuration}分 = ${this.baseDuration + additionalDuration}分`
      } else {
        this.durationTextTarget.textContent = ""
      }
    }
  }

  get baseDuration() {
    const el = this.element.closest(".reservation-steps-container")
    const durationMatch = el
      ?.querySelector(".info-duration")
      ?.textContent.match(/(\d+)分/)
    return durationMatch ? parseInt(durationMatch[1], 10) : 0
  }
}
